import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-100e0aab"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "FlashDiamondRenderContainer"
};
const _hoisted_2 = {
  class: "ft20"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "mt16"
}, "请根据右边九宫格的闪烁顺序，对应到中问的变化规则表，对左边的原始图形进行变化，选出变化后的图形。", -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "点击“开始”按钮启动九官格闪烁。练习模式可以多次点击开始按钮查看闪烁顺序。", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_row = _resolveComponent("el-row");
  const _component_FlashingCircleGraph = _resolveComponent("FlashingCircleGraph");
  const _component_el_col = _resolveComponent("el-col");
  const _component_NineFlashingBoard = _resolveComponent("NineFlashingBoard");
  const _component_BoardFlashingAnimation = _resolveComponent("BoardFlashingAnimation");
  const _component_el_button = _resolveComponent("el-button");
  const _component_AnswerButtonGroup = _resolveComponent("AnswerButtonGroup");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_row, {
    class: "bothCenter"
  }, {
    default: _withCtx(() => [_createElementVNode("span", _hoisted_2, "第" + _toDisplayString($props.data.questionIndex + 1) + "题", 1)]),
    _: 1
  }), _hoisted_3, _hoisted_4, _createVNode(_component_el_row, {
    class: "bothCenter mt16"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 4,
      class: "bothCenter"
    }, {
      default: _withCtx(() => [_createVNode(_component_FlashingCircleGraph, {
        path: $props.data.initial
      }, null, 8, ["path"])]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 8,
      class: "bothCenter"
    }, {
      default: _withCtx(() => [_createVNode(_component_NineFlashingBoard, {
        data: $props.data.board
      }, null, 8, ["data"])]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 8,
      class: "bothCenter"
    }, {
      default: _withCtx(() => [_createVNode(_component_BoardFlashingAnimation, {
        board: $props.data.board,
        flash: $props.data.flash,
        speed: $props.difficulty.flashInterval * 1000,
        ref: "flashAnimation"
      }, null, 8, ["board", "flash", "speed"])]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 4,
      class: "bothCenter"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_button, {
        type: "primary",
        style: {
          "width": "80px",
          "height": "80px",
          "border-radius": "100px"
        },
        onClick: _cache[0] || (_cache[0] = $event => _ctx.$refs.flashAnimation.play())
      }, {
        default: _withCtx(() => [_createTextVNode("开始 ")]),
        _: 1
      })]),
      _: 1
    })]),
    _: 1
  }), _createVNode(_component_AnswerButtonGroup, {
    onChoose: $options.onChoosed,
    review: $props.review,
    reviewMode: $props.reviewMode,
    options: $props.data.candidateAnswers,
    ref: "answerBtns"
  }, {
    default: _withCtx(optionIndex => [_createVNode(_component_FlashingCircleGraph, {
      path: $props.data.candidateAnswers[optionIndex.index]
    }, null, 8, ["path"])]),
    _: 1
  }, 8, ["onChoose", "review", "reviewMode", "options"]), $props.reviewMode ? (_openBlock(), _createBlock(_component_el_row, {
    key: 0,
    class: "flex flex-col bothCenter mt32"
  }, {
    default: _withCtx(() => [_createElementVNode("span", null, "正确答案：" + _toDisplayString($data.letters[$props.data.candidateAnswers.indexOf($props.data.rightAnswer)]), 1), $props.review ? (_openBlock(), _createElementBlock("span", {
      key: 0,
      style: _normalizeStyle({
        color: $props.review.result ? 'green' : 'red'
      })
    }, " 您的答案：" + _toDisplayString($data.letters[$props.data.candidateAnswers.indexOf($props.review.answer)]), 5)) : _createCommentVNode("", true)]),
    _: 1
  })) : _createCommentVNode("", true)]);
}